export default __webpack_public_path__ + "static/media/help.8c238396.svg";